var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LoadingElement',{staticClass:"inline-block",attrs:{"type":_vm.isLink ? _vm.SaLink : 'span',"text-height":false,"to":_vm.broadcasterUrl,"object":_vm.broadcaster}},[_c('BackgroundImage',{attrs:{"src":_vm.imageUrl,"aspect-ratio":_vm.BroadcasterImageAspectRatio}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }